import { usePlayerColor } from "~/jsx/hook";
import { XDreadnought } from "./svg";
import { CSSProperties } from "react";

export const XPlayerDreadnought = ({
  width,
  playerId,
  style,
}: {
  width: number;
  playerId: string;
  style?: CSSProperties;
}) => {
  const color = usePlayerColor(playerId);
  return (
    <XDreadnought width={width} color={color ?? undefined} style={style} />
  );
};
